module.exports = __webpack_public_path__ + "img/focus.f764af9.svg";